import { getModalStyle } from '@/utils/Modal';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import Button from '@/components/Button';

import {
    LocationPin as LocationIcon,
    Circle as CircleIcon,
    History as HistoryIcon,
    Engineering as MaintenanceIcon,
    Close as CloseIcon,
    RemoveRedEye as ViewIcon
} from '@mui/icons-material';

export default function ResourceInfoModal({open, setOpen, fullScreen, resource, openUrlModal}){

	const { sxDialog } = getModalStyle();

    const handleClose = () => {
        setOpen(false);
    }

    return (
        
        <Dialog
            container={fullScreen?.active ? fullScreen?.node?.current : null}
            sx={sxDialog}
            onClose={handleClose}
            open={open}
            fullWidth={true}            
        >                        
        	<DialogTitle className='modal-title'>
                {resource?.name}
            </DialogTitle>            
            <DialogContent className='modal-content text-center'>                
                {
                    resource?.files && resource?.files?.length > 0 &&
                    <div className='mt-4 px-2'>
                        {
                            resource.files?.map((file) => (
                                <div className=''>
                                    <a
                                        className='cursor-pointer mt-4 h-50 border rounded flex items-center justify-center'
                                        onClick={() => openUrlModal(file?.path,true,file?.type,file?.mime,file?.name,'','',false,false)}>
                                        {
                                            file.type === 'image' ? 
                                                <img className='p-2 h-full' src={file?.path}/>
                                            :
                                                file.type === 'pdf' ?
                                                    <div className='w-full h-full'>
                                                        <iframe                                                                                                        
                                                            src={file?.path}                    
                                                            style={{width:'100%', height: '100%', pointerEvents: 'none'}}
                                                        ></iframe>
                                                    </div>
                                                :
                                                    <div className=''><ViewIcon fontSize='large'/></div>
                                        }                                    
                                    </a>
                                </div>
                            ))
                        }       
                    </div>         
                }    
            </DialogContent>            
            <div className="modal-buttons">                
                <div className='mr-1'>
                    <CloseIcon className='action-button-modal text-black' onClick={handleClose}/>
                </div>
            </div>        
        </Dialog>
  );
}